import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Unit_instance1fbcbse1fwigr as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma } from './JsonExceptions.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonNull_getInstance2gh8fwl8w0wl7 as JsonNull_getInstance,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
} from '../JsonElement.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
  DeepRecursiveScope1pqaydvh4vdcu as DeepRecursiveScope,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/DeepRecursive.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { tokenDescription3r6eqmtoxe76u as tokenDescription } from './AbstractJsonLexer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$DeepRecursiveFunction, it, $completion) {
  var tmp0_subject = $this.o2e_1.k2e_1.p2e();
  var tmp;
  if (tmp0_subject === 1) {
    tmp = readValue($this.o2e_1, true);
  } else if (tmp0_subject === 0) {
    tmp = readValue($this.o2e_1, false);
  } else if (tmp0_subject === 6) {
    var tmp_0 = readObject_0($this.o2e_1, $this$DeepRecursiveFunction, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else if (tmp0_subject === 8) {
    tmp = readArray($this.o2e_1);
  } else {
    $this.o2e_1.k2e_1.d2d("Can't begin reading element, unexpected token");
  }
  return tmp;
}
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.k2e_1.q2e(6);
  if ($this.k2e_1.p2e() === 4) {
    $this.k2e_1.d2d('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().f6();
  $l$loop: while ($this.k2e_1.r2e()) {
    var key = $this.l2e_1 ? $this.k2e_1.t2e() : $this.k2e_1.s2e();
    $this.k2e_1.q2e(5);
    var element = $this.u2e();
    // Inline function 'kotlin.collections.set' call
    result.s3(key, element);
    lastToken = $this.k2e_1.v2e();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.k2e_1.d2d('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.k2e_1.q2e(7);
  } else if (lastToken === 4) {
    if (!$this.m2e_1) {
      invalidTrailingComma($this.k2e_1);
    }
    $this.k2e_1.q2e(7);
  }
  return new (JsonObject())(result);
}
function *_generator_readObject__361wel($this, _this__u8e3s4, $completion) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.k2e_1.q2e(6);
  if ($this.k2e_1.p2e() === 4) {
    $this.k2e_1.d2d('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().f6();
  $l$loop: while ($this.k2e_1.r2e()) {
    var key = $this.l2e_1 ? $this.k2e_1.t2e() : $this.k2e_1.s2e();
    $this.k2e_1.q2e(5);
    var tmp = _this__u8e3s4.dw(Unit_instance, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var element = tmp;
    // Inline function 'kotlin.collections.set' call
    result.s3(key, element);
    lastToken = $this.k2e_1.v2e();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.k2e_1.d2d('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.k2e_1.q2e(7);
  } else if (lastToken === 4) {
    if (!$this.m2e_1) {
      invalidTrailingComma($this.k2e_1);
    }
    $this.k2e_1.q2e(7);
  }
  return new (JsonObject())(result);
}
function readObject_0($this, _this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readObject__361wel.bind(VOID, $this, _this__u8e3s4), $completion);
}
function readArray($this) {
  var lastToken = $this.k2e_1.v2e();
  if ($this.k2e_1.p2e() === 4) {
    $this.k2e_1.d2d('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList().w();
  while ($this.k2e_1.r2e()) {
    var element = $this.u2e();
    result.v(element);
    lastToken = $this.k2e_1.v2e();
    if (!(lastToken === 4)) {
      var tmp0 = $this.k2e_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.h28_1;
      if (!condition) {
        var tmp$ret$1 = 'Expected end of the array or comma';
        tmp0.d2d(tmp$ret$1, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.k2e_1.q2e(9);
  } else if (lastToken === 4) {
    if (!$this.m2e_1) {
      invalidTrailingComma($this.k2e_1, 'array');
    }
    $this.k2e_1.q2e(9);
  }
  return new (JsonArray())(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.l2e_1 || !isString) {
    tmp = $this.k2e_1.t2e();
  } else {
    tmp = $this.k2e_1.s2e();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new (JsonLiteral())(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new (DeepRecursiveFunction())(JsonTreeReader$readDeepRecursive$slambda_0($this)), Unit_instance);
}
var JsonTreeReader$readDeepRecursive$slambdaClass;
function JsonTreeReader$readDeepRecursive$slambda() {
  if (JsonTreeReader$readDeepRecursive$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.o2e_1 = this$0;
      }
      w2e($this$DeepRecursiveFunction, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$DeepRecursiveFunction, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof DeepRecursiveScope() ? p1 : THROW_CCE();
        return this.w2e(tmp, p2 instanceof Unit() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    JsonTreeReader$readDeepRecursive$slambdaClass = $;
  }
  return JsonTreeReader$readDeepRecursive$slambdaClass;
}
function JsonTreeReader$readDeepRecursive$slambda_0(this$0) {
  var i = new (JsonTreeReader$readDeepRecursive$slambda())(this$0);
  var l = ($this$DeepRecursiveFunction, it, $completion) => i.w2e($this$DeepRecursiveFunction, it, $completion);
  l.$arity = 2;
  return l;
}
var JsonTreeReaderClass;
function JsonTreeReader() {
  if (JsonTreeReaderClass === VOID) {
    class $ {
      constructor(configuration, lexer) {
        this.k2e_1 = lexer;
        this.l2e_1 = configuration.h29_1;
        this.m2e_1 = configuration.t29_1;
        this.n2e_1 = 0;
      }
      u2e() {
        var token = this.k2e_1.p2e();
        var tmp;
        if (token === 1) {
          tmp = readValue(this, true);
        } else if (token === 0) {
          tmp = readValue(this, false);
        } else if (token === 6) {
          var tmp_0;
          this.n2e_1 = this.n2e_1 + 1 | 0;
          if (this.n2e_1 === 200) {
            tmp_0 = readDeepRecursive(this);
          } else {
            tmp_0 = readObject(this);
          }
          var result = tmp_0;
          this.n2e_1 = this.n2e_1 - 1 | 0;
          tmp = result;
        } else if (token === 8) {
          tmp = readArray(this);
        } else {
          this.k2e_1.d2d('Cannot read Json element because of unexpected ' + tokenDescription(token));
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'JsonTreeReader', VOID, VOID, VOID, [1]);
    JsonTreeReaderClass = $;
  }
  return JsonTreeReaderClass;
}
//region block: exports
export {
  JsonTreeReader as JsonTreeReader1ycreu77eikqj,
};
//endregion

//# sourceMappingURL=JsonTreeReader.mjs.map
